import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { PrimaryColors } from 'src/types/globalTypes';
import { stringToDate } from 'src/utils/formatters';
import { addDate } from 'src/utils/indexs';
import { ButtonA } from '../../DetailPage';
import { FaFilePdf } from 'react-icons/fa';
import { mobilePoint } from 'src/styles/globalStyle';
import { TmarkRightsDetail } from 'src/types/api/trademarkRightsApiTypes';
import { CertPdfChkDetail } from 'src/types/api/patentRightsApiTypes';

const Wrapper = styled.div`
  display: flex;
  gap: 5px;
  color: ${colors.BlueGray_400};
  align-items: center;

  @media (max-width: ${mobilePoint}) {
    display: block;
  }
`;

const enum PdfStatus {
  D = '',
  Y = '※智慧財產權ｅ網通列印資料，僅供參考',
  P = '※商標證書影像檔自公告日後第15日始予提供',
  N = '※商標證書影像檔暫未提供',
  O = `※商標證書影像檔自公告日期2017-09-01起提供`,
}

interface Iprops {
  data: TmarkRightsDetail;
  certPdfChkDetail: CertPdfChkDetail;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * PDF檔下載按鈕。
 */
const PdfDownloadTmark: React.FC<Iprops> = ({ data, certPdfChkDetail, colorType, noContent }) => {
  /** 指定日期，自該日期後案件提供PDF檔 */
  const TMARK_SDATE = new Date('2017-09-01');

  const getStatus = () => {
    let pdfStatus = PdfStatus.D;
    if (!data.delReason) {
      const regNoticeDate = stringToDate(data.regNoticeDate);

      if (certPdfChkDetail.pdfUrl) {
        // 如有檔案，公告日期+15日後才開放預覽及下載
        const openDate = regNoticeDate && addDate(regNoticeDate, 15);
        if (openDate && new Date().getTime() >= openDate.getTime()) {
          pdfStatus = PdfStatus.Y;
        } else {
          pdfStatus = PdfStatus.P;
        }
      } else {
        // 如無檔案，判斷公告日期是否晚於指定時間
        if (regNoticeDate && regNoticeDate.getTime() <= TMARK_SDATE.getTime()) {
          pdfStatus = PdfStatus.O;
        } else {
          pdfStatus = PdfStatus.N;
        }
      }
    }
    return pdfStatus;
  };
  const status = getStatus();

  return status === PdfStatus.Y ? (
    <Wrapper>
      <ButtonA
        color={colorType.forth}
        href={process.env.REACT_APP_API_URL + certPdfChkDetail.pdfUrl}
      >
        <FaFilePdf color={colorType.seventh} />
        PDF
      </ButtonA>
      <div>{status}</div>
    </Wrapper>
  ) : (
    <Wrapper>
      {noContent}
      <div>{status}</div>
    </Wrapper>
  );
};

export default PdfDownloadTmark;
